import { FC } from 'react'
import styles from './one-news-view.module.scss'
import { INews } from '@/types/news.interface'
import MainLayout from '@/components/layouts/MainLayout'
import FullNewsCard from '@/components/cards/FullNewsCard'
import SharedHostingOfferCard from '@/components/cards/OfferCard/SharedHostingOfferCard'
import FreeMailOfferCard from '@/components/cards/OfferCard/FreeMailOfferCard'
import VpsOfferCard from '@/components/cards/OfferCard/VpsOfferCard'
import OfferCard from '@/components/cards/OfferCard'

type OneNewsViewProps = {
  news: INews
}

const OneNewsView: FC<OneNewsViewProps> = ({ news }) => {

  return (
    <MainLayout>
      <section className={styles.section}>
        <div className="container">
          <div className={styles.wrapper}>
            <div className={styles.content}>
              <FullNewsCard {...news} />
            </div>
            <div className={styles.offers}>
              <OfferCard.Wrapper className={styles.offers}>
                <SharedHostingOfferCard />
                <FreeMailOfferCard />
                <VpsOfferCard />
              </OfferCard.Wrapper>
            </div>
          </div>
        </div>
      </section>
    </MainLayout>
  )
}

export default OneNewsView
